import { QueryClient, useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { SpaEntityType } from 'shared-types/Spa';

export const getSpaFacility = async (
  propertyId: number,
  language: string,
  spaFacilityId: any,
  params: { arrivalDate: string | null }
) => {
  const { data } = await request.get(`${propertyId}/facilities/${spaFacilityId}/${language}`, {
    params,
  });
  return data as SpaEntityType;
};

export const getSpaFacilityPrefetch = async (
  queryClient: QueryClient,
  propertyId: number,
  language: string,
  spaFacilityId: any,
  arrivalDate: string | null,
  showUnpublished = false
) => {
  await queryClient.prefetchQuery(
    getAvailableSpaFacilityKey(propertyId, language, spaFacilityId, {
      arrivalDate,
    }),
    () =>
      getSpaFacility(propertyId, language, spaFacilityId, {
        arrivalDate,
        ...(showUnpublished ? { showUnpublished: 1 } : {}),
      }),
    { cacheTime: Infinity, staleTime: Infinity }
  );
};

export const useGetSpaFacility = (
  propertyId: number,
  language: string,
  spaFacilityId: any,
  arrivalDate: string | null,
  enabled = true
) => {
  const { data, isFetching } = useQuery({
    queryKey: getAvailableSpaFacilityKey(propertyId, language, spaFacilityId, {
      arrivalDate,
    }),
    queryFn: () =>
      getSpaFacility(propertyId, language, spaFacilityId, {
        arrivalDate,
      }),
    cacheTime: Infinity,
    staleTime: Infinity,
    keepPreviousData: true,
    enabled,
  });
  return { data, isFetching };
};

export const getAvailableSpaFacilityKey = (
  propertyId: number,
  language: string,
  spaFacilityId: any,
  params: {
    arrivalDate: string | null;
  }
) => [
  'spaFacility',
  'available',
  propertyId,
  parseInt(spaFacilityId, 10),
  ...Object.values(params),
  language,
];
